module.exports = __webpack_public_path__ + "img/cadreSurvol.a0789422.png";